import { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';

const EditarPrestServico = () => {
    const { id } = useParams();
    const navigate = useNavigate();    
    const { showNotification } = useNotification();    

    const [name, setName] = useState('');
    const [company, setCompany] = useState('');
    const [phone, setPhone] = useState('');
    const [serviceType, setServiceType] = useState('');

    useEffect(() => {
        const fetchPrestador = async () => {
            try {
                const response = await authFetch(`service-provider/${id}`, {                    
                });

                if (!response.ok) throw new Error('Erro ao buscar prestador');

                const data = await response.json();
                setName(data.name);
                setCompany(data.company);
                setPhone(data.phone);
                setServiceType(data.serviceType);
            } catch (error) {
                showNotification("danger", "Erro ao buscar prestador");
            }
        };

        fetchPrestador();
    }, [showNotification]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await authFetch(`service-provider`, {
                method: 'PUT',                
                body: JSON.stringify({ id, name, company, phone, serviceType })
            });

            if (!response.ok) throw new Error('Erro ao atualizar prestador');

            showNotification("success", "Prestador atualizado com sucesso!");
            navigate('/PrestServicos');
        } catch (error) {
            showNotification("danger", "Erro ao atualizar prestador");
        }
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');

        if (value.length > 11) {
            value = value.slice(0, 11); // Limita a 11 dígitos (incluindo DDD)
        }

        if (value.length <= 10) {
            value = value.replace(/(\d{2})(\d)/, '($1) $2');
            value = value.replace(/(\d{4})(\d)/, '$1-$2');
        } else {
            value = value.replace(/(\d{2})(\d)/, '($1) $2');
            value = value.replace(/(\d{5})(\d)/, '$1-$2');
        }

        setPhone(value);
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <aside>
                    <h4 className="font-weight-bolder mb-0">Editar Prestador de Serviço</h4>
                </aside>
                <form onSubmit={handleSubmit}>
                    <fieldset className="col-md-6">
                        <div className="mb-3">
                            <label>Nome</label>
                            <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
                        </div>
                        <div className="mb-3">
                            <label>Empresa</label>
                            <input type="text" className="form-control" value={company} onChange={(e) => setCompany(e.target.value)} required />
                        </div>
                        <div className="mb-3">
                            <label>Telefone</label>
                            <input
                                type="text"
                                className="form-control"
                                value={phone}
                                onChange={handlePhoneChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label>Tipo de Serviço</label>
                            <input type="text" className="form-control" value={serviceType} onChange={(e) => setServiceType(e.target.value)} required />
                        </div>
                        <div className="card-footer" style={{ paddingLeft: "0" }}>
                            <Link to="/PrestServicos" className="btn btn-info btn-sm">Voltar</Link>
                            <button type="submit" className="btn btn-primary btn-sm mx-1">Salvar</button>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    );
};

export default EditarPrestServico;
